import { Z_INDEX } from '@va/constants';
import { Tour } from '@va/ui/feature-tour';
import { useCallback, useEffect, useState } from 'react';
import { ACTIONS, Controls, EventData, LIFECYCLE, Options, STATUS, Step } from 'react-joyride';
import { FeatureTourButton } from '../..';

export type FeatureTourHelpers = { setRun: (bool: boolean) => void };

export const FeatureTour = ({
  steps,
  completed,
  getHelpers,
  onComplete,
  onStart,
  options,
  onClose,
}: {
  steps: Step[];
  completed: boolean;
  getHelpers?: (helpers: FeatureTourHelpers) => void;
  onComplete?: () => void;
  onStart?: () => void;
  onClose?: () => void;
  options?: Partial<Options>;
}) => {
  const [run, setRun] = useState(false);

  const onClickFunc = useCallback(() => {
    setTimeout(() => {
      setRun(true);
    }, 250);
    onStart?.();
  }, [onStart]);

  const onEvent = useCallback(
    (data: EventData, controls: Controls) => {
      const { action, lifecycle, status } = data;

      if (action === ACTIONS.CLOSE || status === STATUS.FINISHED) {
        setRun(false);
        // v3's reset(true) immediately restarts the tour; without it, it only rewinds to step 0
        controls.reset();
        onClose?.();
        window.disableClickOutside = false;
      }

      if (lifecycle === LIFECYCLE.COMPLETE && status === STATUS.FINISHED) {
        onComplete?.();
      }
    },
    [onClose, onComplete],
  );

  useEffect(() => {
    getHelpers?.({ setRun: setRun });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <FeatureTourButton onClick={onClickFunc} completed={completed} />
      <Tour
        options={{
          zIndex: Z_INDEX.featureTour,
          primaryColor: window.PRIMARY_COLOR,
          ...options,
        }}
        run={run}
        steps={steps}
        onEvent={onEvent}
      />
    </>
  );
};
